import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'explorerFilter',
    standalone: true
})
export class ExplorerFilterPipe implements PipeTransform {

  transform(value: any, filterName: string): any {
    switch (filterName) {
      case 'formatPermissionMode':
        return this.formatPermissionMode(value);
      case 'fileIsDir':
        return this.fileIsDir(value);
      case 'formatFileSize':
        return this.formatFileSize(value);
      case 'formatFileDate':
        return this.formatFileDate(value);
      default:
        return value;
    }
  }

  private formatPermissionMode(mode: any): any {
    if (mode !== null) {
      const res = [];
      const s = ['x', 'w', 'r'];

      for (let i = 0; i < 3; i++) {
        for (let j = 0; j < 3; j++) {
          if ((mode >> (i * 3 + j))) {
            res.unshift(s[j]);
          } else {
            res.unshift('-');
          }
        }
      }
      res.unshift(mode & 0o40000 ? 'd' : '-');
      return res.join('');
    }
    return '';
  }

  private fileIsDir(mode: any): any {
    let fileMode = mode;
    if (fileMode !== null) {
      fileMode = parseInt(fileMode, 10);
      fileMode -= fileMode & 0o777;
      return fileMode === 0o40000 || fileMode === 0o120000;
    }
    return false;
  }

  private formatFileSize(size: any): any {
    let formattedSize = '';

    if (size < 1024) {
      formattedSize = size + ' B';
    } else if (size >= 1024 && size < 1024 * 1024) {
      formattedSize = Math.round(size / 1024) + ' Kb'
    } else {
      formattedSize = Math.round(size / (1024 * 1024)) + ' Mb'
    }
    return formattedSize;
  }

  private formatFileDate(inputString: any): any {
    const input = new Date(inputString);
    input.toLocaleDateString;
    if (input instanceof Date) {
      return input.toISOString().substring(0, 19).replace('T', ' ');
    }else{
      return input;
    }
  }

}
